import { t } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';

import Tasks from 'APP/Tasks';

// Needs Bff implementation
export default async ({ channelId, userId }) => {
  try {
    logger.get('Tasks').debug('streaming.forceMute', { channelId, userId });
  } catch (e) {
    logger.get('Tasks').error('streaming.forceMute', e);
    Tasks.app.showAlert(t('calls_error_appeared'));
  }
};
